<template>
    <section class="interaction-summary-header">
        <p class="interaction-summary-heading">
            ANALYSIS<span class="interaction-summary-text"> / WORKSTREAM INTERACTION SUMMARY</span>
        </p>
    </section>
</template>

<script setup lang="ts">
</script>

<style scoped lang="scss" src="./style.scss">
</style>